const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-script';
const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit';

const isRecaptchaReady = () =>
  typeof window !== 'undefined' &&
  window.grecaptcha &&
  typeof window.grecaptcha.render === 'function';

export const loadRecaptchaScript = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (isRecaptchaReady()) {
    return Promise.resolve();
  }

  const existing = document.getElementById(RECAPTCHA_SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      if (isRecaptchaReady()) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Failed to load reCAPTCHA')), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = RECAPTCHA_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.body.appendChild(script);
  });
};

export { isRecaptchaReady };
